import { request } from 'utils';
import { normalize } from 'normalizr';

import {
  FETCH_FOREX_PRODUCTS_REQUEST,
  FETCH_FOREX_PRODUCTS_FAILURE,
  FETCH_FOREX_PRODUCTS_SUCCESS,
} from 'actionTypes';

import { products as productSchema } from 'schemas';

const DEFAULT_CURRENCY = 'usd';

export const fetchProductsIdsByCurrency = async currency => {
  const { data } = await request({
    url: `${process.env.APP_PRODUCTS_API_ROOT}list`,
    params: { product_type: '6', currency },
  });

  return data.join(',');
};

export const fetchProductsByCurrency = props => async dispatch => {
  try {
    dispatch({
      type: FETCH_FOREX_PRODUCTS_REQUEST,
      payload: {},
    });

    const currencyParam = props?.currency || DEFAULT_CURRENCY;

    const productsIds = await fetchProductsIdsByCurrency(currencyParam);

    const { data } = await request({
      url: `${process.env.APP_PRODUCTS_API_ROOT}data`,
      params: { locale: props.intl.locale, ids: productsIds },
    });

    const {
      entities: { products: entities = {} },
      result: ids = [],
    } = normalize(data, productSchema);

    const uniqueIds = [...new Set(ids)];

    return dispatch({
      type: FETCH_FOREX_PRODUCTS_SUCCESS,
      payload: {
        entities,
        ids: uniqueIds,
      },
    });
  } catch (error) {
    return dispatch({
      type: FETCH_FOREX_PRODUCTS_FAILURE,
      payload: {},
    });
  }
};
